/** @jsx jsx */
import { Fragment } from 'react';

import { css, jsx } from '@emotion/react';
import upperFirst from 'lodash/upperFirst';

import { token } from '@atlaskit/tokens';

import SubGroup from './components/subgroup';
import groupedTokens from './grouped-tokens';

export const listStyleReset = css({
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const listItemStyleReset = css({
  marginTop: 0,
  marginBottom: 0,
});

const displayHeadingContainerStyles = css({
  marginBottom: token('space.200', '16px'),
});

const displayHeadingStyles = css({
  margin: 0,
  fontSize: token('font.size.300', '20px'),
  fontWeight: token('font.weight.medium', '500'),
  lineHeight: token('font.lineHeight.300', '24px'),
});

const rampStyles = css({
  marginBottom: token('space.500', '40px'),
});

/**
 * __Color palette ramps__
 *
 * Color palette ramps visually display color tokens.
 */
const ColorPaletteRamps = () =>
  groupedTokens.length > 0 ? (
    <ul css={listStyleReset}>
      {groupedTokens.map(group => (
        <li key={group.name} css={rampStyles}>
          {group.name && group.name !== 'colors' && (
            <div css={displayHeadingContainerStyles}>
              <h3 css={displayHeadingStyles}>{upperFirst(group.name)}</h3>
            </div>
          )}
          {group.subgroups.length > 0 && <SubGroup {...group} />}
        </li>
      ))}
    </ul>
  ) : (
    <Fragment></Fragment>
  );

export default ColorPaletteRamps;
